import { ModalSmartDeviceLinkDetails as SmartDeviceLinkDetails } from '#components'
import axios from 'axios'

export default {
  methods: {
    loadSmartDevices (type, id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/' + type + 's/' + id + '/smartdevices.json?sorters[]={"field":"name","dir":"asc"}&apikey=' + this.apiKey + this.versionStr)
        } catch(e) {
          this.showError(e)
          reject(e)
          return
        }
        this.smartdevices = response.data
        resolve(response.data)
      })
    },
    editSmartDevice(link) {
      this.showModal('smartdevicelinkdetails', SmartDeviceLinkDetails, {
        props: {
          selectedSmartDeviceLink: link
        },
        events: {
          save: this.saveSmartDevice,
          remove: this.deleteSmartDevice
        },
        handlers: {},
        width: 800
      })
    },
    addSmartDevice() {
      return this.editSmartDevice({
        data: {},
        id: 'new-' + (new Date().getTime())
      })
    },
    deleteSmartDevice(link) {
      if (!this.resource || !this.resource.ownResource_smartdevice || !this.resource.ownResource_smartdevice.length) {
        return
      }
      this.resource.ownResource_smartdevice = this.resource.ownResource_smartdevice.filter(l => l.id !== link.id)
    },
    saveSmartDevice(link) {
      if (!this.resource || !this.resource.ownResource_smartdevice) {
        return
      }
      for (let i = 0; i < this.resource.ownResource_smartdevice.length; i++) {
        if (this.resource.ownResource_smartdevice[i].id === link.id) {
          this.resource.ownResource_smartdevice[i] = link
          return
        }
      }
      this.resource.ownResource_smartdevice.push(link)
    },
    makeSmartDeviceTitle (link) {
      if (!link || !link.smartdevice) {
        return ''
      }
      return link.smartdevice.name + ' (ID: ' + link.smartdevice.id + ')'
    },
    makeSmartDeviceDesc (link) {
      if (!link || !link.smartdevice) {
        return ''
      }
      const data = link.data
      const timeTypes = {
        'before_reservation_starts': 'hours before the reservation starts',
        'after_reservation_starts': 'hours after the reservation starts',
        'before_reservation_ends': 'hours before the reservation ends',
        'after_reservation_ends': 'hours after the reservation ends'
      }
      switch(link.smartdevice.type) {
        case 'lock':
          // This is just too long
          // return (data.startoffset != 1 ? data.startoffset + ' ' : '') + this._(timeTypes['before_reservation_starts']) + ' ➜ ' + (data.endoffset != 1 ? data.endoffset + ' ' : '') + this._(timeTypes['after_reservation_ends'])
          let so = data.startoffset
          let eo = data.endoffset
          if (!so) {
            so = 0
          }
          if (!eo) {
            eo = 0
          }
          return this._('%s hours before').replace('%s', so) + ' ➜ ' + this._('%s hours after').replace('%s', eo)
        case 'temperature':
          return data.temperature + ' ℃, ' + data.offset + ' ' + this._(timeTypes[data.timetype])
      }
      return ''
    },
    makeSmartDeviceIcon (link) {
      if (!link || !link.smartdevice) {
        return ''
      }
      switch (link.smartdevice.type) {
        case 'lock':
          return 'lock'
        case 'temperature':
          return 'temperature-list'
      }
      return ''
    },
    makeSmartDeviceType (link) {
      if (!link || !link.smartdevice) {
        return ''
      }
      switch (link.smartdevice.subtype) {
        case 'seam':
          return this._('Seam lock')
        case 'seamacs':
          return this._('Seam ACS')
        case 'ratna':
          return this._('Ratna apartment')
        case 'igloo':
          return this._('Igloohome lock')
        case 'yale':
          return this._('Yale lock')
        case 'adax':
          return this._('Adax heater')
      }
      switch (link.smartdevice.type) {
        case 'lock':
          return this._('Lock')
        case 'temperature':
          return this._('Temperature')
      }
      return ''
    }
  }
}